import { render, staticRenderFns } from "./VisualizacionArtistasRelacionados.vue?vue&type=template&id=2044ec6b&scoped=true&"
import script from "./VisualizacionArtistasRelacionados.vue?vue&type=script&lang=js&"
export * from "./VisualizacionArtistasRelacionados.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionArtistasRelacionados.vue?vue&type=style&index=0&id=2044ec6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044ec6b",
  null
  
)

export default component.exports